import script from "./BusinessHours.vue?vue&type=script&lang=ts&setup=true"
export * from "./BusinessHours.vue?vue&type=script&lang=ts&setup=true"

import "./BusinessHours.vue?vue&type=style&index=0&id=19022f28&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19022f28"]])

export default __exports__